import React, { useState, useEffect } from "react";
import { Dropdown } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import CreateAxios from "../axiosComponent/create";
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";

const CHAInput = ({ field: { name }, form: { setFieldValue }, ...props }) => {
  const [ChaDropdown, setChaDropdown] = useState([]);
  const [isloading, setisloading] = useState(false);
  useEffect(() => {
    allAxiosCommonRequest({ url: "masters/cha", method: "get" })
      .then((response) => {
        console.log("+++++++++++++++++++++++++++++++++++++")
        console.log(response)
        setChaDropdown(response.data.resultSet);
      })
      .catch((error) => console.log(error));
  }, []);

  let chaDropdownOptions = [];
  if (ChaDropdown.length > 0) {
    ChaDropdown.map((object, index) => {
      let temp = {};
      temp.key = object.CHACode;
      temp.text = object.CHAName;
      temp.value = object.CHAId;
      temp.raw = { ...object };
      return (chaDropdownOptions[index] = temp);
    });
  }

  let handleChange = (value, data) => {
    setFieldValue(name, data.value);
    if (props?.placeholderName) {
      let selected = data.options.filter((object, index) => {
        if (object.value == data.value) {
          return object.text
        }
      });
      setFieldValue(props.placeholderName, selected[0]?.text);
    }
  };
  return (
    <div className="">
      <Dropdown
        selection
        clearable
        loading={isloading ? true : false}
        style={{ width: "100%" }}
        onChange={handleChange}
        options={chaDropdownOptions}
        placeholder={props.placeholder}
        {...props}
      />
    </div>
  );
};

export default CHAInput;
